import { Injectable } from "@angular/core";
import * as ExcelJS from 'exceljs'
@Injectable({
  providedIn: 'root'
})
export class ExportExcelService {
  constructor() { }
  async excelfileCreationFromJson(fileData, fileName, sheetName, isBaseMappingHeaderChanges = true, isContainerMappingEnabled = true) {
    const workBook = new ExcelJS.Workbook();
    const workSheet = workBook.addWorksheet(sheetName);
    const headers = this.getModifiedHeader(fileData, isBaseMappingHeaderChanges, isContainerMappingEnabled);
    workSheet.columns = headers;
    workSheet.addRows(fileData);
    this.modifyExcel(workSheet.getRow(1), workSheet);
    const buffer = await workBook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }
  getModifiedHeader(data, isBaseMappingHeaderChanges = true, isContainerMappingEnabled = true) {
    return Object.keys(data[0]).map(key => {
      let header = key;
      if (key.toLocaleLowerCase() === 'id') {
        header = isBaseMappingHeaderChanges ? 'Container Id' : '#';
      }
      if (key.toLocaleLowerCase() === 'code') {
        header = isContainerMappingEnabled ? 'Container Code' : 'Application Code';
      }
      else if (key.toLocaleLowerCase() === 'containercode') header = 'Container Code';
      else if (key.toLocaleLowerCase() === 'name') header = 'Container Name';
      else if (key.toLocaleLowerCase() === 'memberfirmcode') header = 'Member Firm Code';
      else if (key.toLocaleLowerCase() === 'countrycode') header = 'Country Code';
      else if (key.toLocaleLowerCase() === 'countryname') header = 'Country Name';
      else if (key.toLocaleLowerCase() === 'officecode') header = 'Office Code';
      else if (key.toLocaleLowerCase() === 'geocode') header = 'Geo Code';
      return { header, key }
    }).filter(header => header.key.toLowerCase() !== "environmentid")
  };
  modifyExcel(header, workSheet) {
    header.eachCell((cell) => {
      cell.font = { bold: true, size: 14 };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFDDDDDD' },
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      }
    });
    workSheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    });
  }
}
